import { useLazyQuery, useMutation } from '@apollo/client'
import React, { useState } from 'react'
import {
  GENERATE_CHECKSUM,
  RECHARGE_FLEET_OWNER,
} from '../../../Services/cabapi/fleetggl'
import { toast } from 'react-toastify'
import { getDecryptedSessionStorageVariable } from '../../../utils/encryptStorage'
import { kWebsiteLive, Paytm_MID_LIVE } from '../../../Services/constant'
import axios from 'axios'
import Swal from 'sweetalert2'

const AddMoney = ({
  isOpen,
  onClose,
  onAccept,
  onDecline,
  selectedBooking,
  refetch,
}) => {
  // State to manage selected amount
  const fleetid = getDecryptedSessionStorageVariable('fleetId')
  const fleetFirstName = getDecryptedSessionStorageVariable('firstName')
  const fleetLastName = getDecryptedSessionStorageVariable('lastName')
  const fleetMobileNumber =
    getDecryptedSessionStorageVariable('fleetMobileNumber')
  console.log('fleetMobileNumber', fleetMobileNumber)
  const [amount, setAmount] = useState(null)
  const [selectedAmount, setSelectedAmount] = useState(null)
  const [getCheckSum] = useLazyQuery(GENERATE_CHECKSUM)

  // Mutation to recharge fleet owner
  const [rechargeFleetOwner, { data, loading, error }] =
    useMutation(RECHARGE_FLEET_OWNER)

  // Predefined amounts for selection
  const amounts = [1000, 2000, 5000]

  // Handle amount selection
  const handleAddMoney = (selectedAmount) => {
    setSelectedAmount(selectedAmount)
    setAmount(selectedAmount)
  }

  const handleCompleteTransaction = async (transactionId) => {
    const obj = {
      fleetOwnerId: fleetid,
      balance: amount,
      transactionId: transactionId,
      updatedBy: fleetFirstName + fleetLastName,
      updatedName: fleetFirstName + fleetLastName,
      // operationCity: 'Pune',
    }

    try {
      const { data } = await rechargeFleetOwner({
        variables: {
          createRechargeInput: obj,
        },
      })
      if (data) {
        console.log('inside got data')
        refetch()
      }
      refetch()
      onClose()
      Swal.fire({
        title: 'Success',
        text: `${data.rechargeFleetOwner}.Transaction Id - ${transactionId}`,
        icon: 'success',
      })
    } catch (err) {
      Swal.fire({
        title: 'Failed',
        text: `Recharge Failed!`,
        icon: 'success',
      })
      console.error('Error recharging fleet owner:', err)
    }
  }
  const handleRecharge = async () => {
    if (!amount) {
      alert('Please select an amount')
      return
    }
    let orderId1 = `OrderID_${Date.now()}`
    const mid = Paytm_MID_LIVE
    const orderId = orderId1
    const callbackUrl = `https://secure.paytmpayments.com/theia/paytmCallback?ORDER_ID=${orderId}`
    try {
      const body = {
        requestType: 'Payment',
        mid: Paytm_MID_LIVE,
        websiteName: kWebsiteLive,
        orderId: orderId,
        txnAmount: {
          value: parseFloat(selectedAmount).toFixed(2),
          currency: 'INR',
        },
        userInfo: {
          custId: fleetid,
          mobile: fleetMobileNumber,
        },
        callbackUrl: callbackUrl,
      }
      getCheckSum({
        variables: {
          body: JSON.stringify(body),
        },
        fetchPolicy: 'network-only',
      })
        .then(async (response) => {
          const checksum = response.data.generateCheckSum
          const requestBody = {
            body: body,
            head: {
              signature: checksum,
            },
          }
          const url = `https://secure.paytmpayments.com/theia/api/v1/initiateTransaction?mid=${mid}&orderId=${orderId}`
          const headers = {
            'Content-Type': 'application/json',
          }
          const response1 = await axios.post(url, requestBody, {
            headers: headers,
          })
          const res = response1?.data?.body?.resultInfo
          if (
            res.resultStatus === 'S' &&
            res.resultMsg === 'Success' &&
            res.resultCode === '0000'
          ) {
            const txnToken = response1?.data?.body?.txnToken

            const config = {
              root: '',
              style: {
                bodyBackgroundColor: '#fafafb',
                themeBackgroundColor: '#0FB8C9',
                themeColor: '#ffffff',
                headerBackgroundColor: '#284055',
                headerColor: '#ffffff',
              },
              data: {
                orderId: orderId,
                token: txnToken,
                tokenType: 'TXN_TOKEN',
                amount: selectedAmount,
                currency: 'INR',
              },
              payMode: {
                order: ['CC', 'DC', 'NB', 'UPI', 'PPBL', 'PPI', 'BALANCE'],
              },
              website: kWebsiteLive,
              flow: 'DEFAULT',
              merchant: {
                mid: mid,
                redirect: false,
              },
              handler: {
                transactionStatus(paymentStatus) {
                  console.log('paymentStatus', paymentStatus)
                  if (paymentStatus.STATUS == 'TXN_SUCCESS') {
                    toast.success('Transaction completed successfully')
                    window.Paytm.CheckoutJS.close()
                    console.log('called after close')
                    handleCompleteTransaction(paymentStatus?.TXNID)
                  } else {
                    window.Paytm.CheckoutJS.close()
                    toast.error('Transaction failed')
                  }
                },
                notifyMerchant(eventName, data) {
                  console.log('notifyMerchant')
                },
              },
            }
            if (window.Paytm && window.Paytm.CheckoutJS) {
              window.Paytm.CheckoutJS.init(config)
                .then(function onSuccess() {
                  window.Paytm.CheckoutJS.invoke()
                })
                .catch(function onError(error) {
                  toast.error('Failed to complete transaction')

                  console.log('Error => ', error)
                })
            }
          }
        })
        .catch((error) => {
          console.log('error in payment', error)
        })
    } catch (error) {
      toast.error('Something went wrong')
    }
  }

  return (
    <div className="fixed z-20 inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white rounded-lg p-6 w-11/12 sm:w-96 shadow-lg relative">
        <div className="text-center mb-4 flex justify-between">
          <h4 className="text-lg font-semibold">Add Money</h4>
          <button
            onClick={() => {
              onClose()
            }}
            className="text-xl font-bold text-red-500 hover:text-red-700"
          >
            X
          </button>
        </div>
        <div>
          <span>Select amount :</span>
        </div>
        {/* Display amount selection buttons */}
        <div className="grid grid-cols-3 gap-4 mt-3">
          {amounts.map((amount, index) => (
            <span
              key={index}
              onClick={() => handleAddMoney(amount)} // Set the selected amount
              className={`p-2 border border-sky-300 rounded-lg text-center cursor-pointer ${
                amount === selectedAmount ? 'bg-sky-300' : ''
              }`}
            >
              &#8377; {amount}
            </span>
          ))}
        </div>

        {/* Display selected amount */}
        {amount && (
          <div className="mt-4 text-center">
            Selected Amount: &#8377; {amount}
          </div>
        )}

        {/* Handle submit button */}
        <div className="mt-4 flex justify-center">
          <button
            onClick={() => {
              onClose()
              handleRecharge()
            }}
            disabled={loading || !amount} // Disable if loading or no amount is selected
            className="bg-blue-500 text-white py-2 px-6 rounded-lg disabled:opacity-50"
          >
            {loading ? 'Processing...' : 'Recharge'}
          </button>
        </div>

        {/* Show error if exists */}
        {error && (
          <div className="mt-4 text-center text-red-500">{error.message}</div>
        )}

        {/* Show success message */}
        {data && data.rechargeFleetOwner && (
          <div className="mt-4 text-center text-green-500">
            Recharge Successful! {data.rechargeFleetOwner}
          </div>
        )}
      </div>
    </div>
  )
}

export default AddMoney
